export function deEscapeHtml(uids: string | string[]): string | string[] {
  if (!uids) {
    return '';
  }
  return Array.isArray(uids) ? uids.map((uid: string) => uid.replace('%2B', '+')) : uids.replace('%2B', '+');
}
